import styled from '@emotion/styled';

export const CourseEmployeesFiltersContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;
